export default class UrlHelper {

    static getUrlWithoutAnchor(url = document.location.href) {
        return url.indexOf('#') >= 0 ? url.split('#')[0] : url;
    }

    static getAnchor(url = document.location.href) {
        return url.indexOf('#') >= 0 ? url.split('#')[1] : '';
    }
}